import { useState } from 'react'
import { Contracts } from '../../Client/Contracts'
import { Experiments } from '../../Client/Experiments'
import Tabs from 'src/Components/Tabs'
import { IClient } from 'src/utils/Interfaces/client.interface'
import style from './style.module.scss'

export const ClientDataTabs = ({ data }: { data: IClient }) => {
  const [activeTab, setActiveTab] = useState<number>(0)

  return (
    <div className={style.tabs}>
      <Tabs list={['Contracts', 'Experiments']} name="client" onChange={(i) => setActiveTab(i)} />
      <div className={style.tabs_content}>
        {activeTab === 0 && <Contracts items={data?.contracts || []} />}
        {activeTab === 1 && <Experiments items={data?.contracts || []} />}
      </div>
    </div>
  )
}
